import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import BalanceSheetContent from './BalanceSheetContent';
import { BalanceSheetProvider } from './BalanceSheetContext';

const BalanceSheet = () => {
  const {
    resource: balanceSheetStepResource,
  } = useMetaLayoutContext();

  return (
    <BalanceSheetProvider>
      <BalanceSheetContent balanceSheetStepResource={balanceSheetStepResource} />
    </BalanceSheetProvider>
  );
};

BalanceSheet.propTypes = {
};

BalanceSheet.defaultProps = {
};


export default BalanceSheet;
